import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

const defaultHeadline =
    '설계부터 운영까지, 기업 업무에 맞는 IT를 CODAM과 함께 준비해 보세요.'

/**
 * @param {{ headline?: string, ctaLabel?: string }} [props]
 */
const NewsletterTwo = (props = {}) => {
    const { headline = defaultHeadline, ctaLabel = '프로젝트 문의하기' } = props
    return (
        <Fragment>
            <section className="call-to-action pt-100 pb-100">
                <img className="call-shape shape-one" src="/assets/img/shape/line-round-8c.svg" alt="배경 도형"/>
                <img className="call-shape shape-two d-none d-lg-inline-block" src="/assets/img/icon/icon-39c.svg" alt=""/>
                <img className="call-shape shape-three d-none d-lg-inline-block" src="/assets/img/icon/icon-40c.svg" alt=""/>
                <img className="call-shape shape-four d-none d-lg-inline-block" src="/assets/img/icon/icon-41c.svg" alt=""/>
                <img className="call-shape shape-five d-none d-lg-inline-block" src="/assets/img/icon/icon-42c.svg" alt=""/>
                <img className="call-shape shape-six d-none d-lg-inline-block" src="/assets/img/icon/icon-43c.svg" alt=""/>
                <img className="call-shape shape-seven d-none d-lg-inline-block" src="/assets/img/icon/icon-44c.svg" alt=""/>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-md-8">
                            <div className="call-to-wrapper">
                                <h3 className="title-big mb-60" data-aos="fade-up">
                                    {headline}
                                </h3>
                                <Link className="theme_btn" data-aos="fade-up" to="/contact">
                                    {ctaLabel}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default NewsletterTwo
